import React, { Component } from 'react';
import FranchisePlans from './FranchisePlans';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import SubscriptionModal from './../../common/components/SubscriptionModal';
import subscriptionService from '../../common/services/subscriptionService';
import { fetchFranchiseDetails } from '../../state/actions/franchise';
import { spacePascalWord } from './../../common/utils/helpers';
import profileType from './../../common/utils/profileType';

class UpgradeFranchisePlan extends Component {
  MySwal = withReactContent(Swal);
  state = {
    id: '',
    subscriptionPlans: {},
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const { franchise } = this.props;

    if (!franchise || !franchise.id) this.props.fetchFranchiseDetails(id);

    const subscriptionPlans = await subscriptionService.getSubscriptionPlans();

    this.setState({
      id,
      subscriptionPlans,
    });
  }

  planChange = plan => {
    const { id, isOwner } = this.props.franchise;
    if (!isOwner) this.props.history.push(`/investors/${id}`);

    this.promptPayment(plan);
  };

  promptPayment = plan => {
    const plans = [...this.state.subscriptionPlans];
    const selectedPlan = plans.find(x => x.planType === plan);

    const { email, phoneNumber } = this.props.currentUser;
    const { id: franchiseId, email: workEmail } = this.props.franchise;
    if (email && selectedPlan && franchiseId) {
      this.MySwal.fire({
        customClass: 'bg-transparent w-lg-30 w-md-30 w-90',
        showConfirmButton: false,
        html: (
          <SubscriptionModal
            planId={selectedPlan.planId}
            amount={selectedPlan.amount}
            userEmail={email}
            listingEmail={workEmail}
            userPhone={phoneNumber}
            listingId={franchiseId}
            listingType={profileType.Franchise}
            redirectTo={`user/franchises/${franchiseId}`}
            successMessage={`Subscription to ${spacePascalWord(
              plan,
            )} plan was successful`}
            history={this.props.history}
          ></SubscriptionModal>
        ),
      });
    }
  };

  render() {
    const { franchise } = this.props;
    const currentPlan =
      franchise && franchise.subscription && franchise.subscription.planType;

    return (
      <div className="scale-down-lg-7">
        <h3 className="text-center">Upgrade/change Franchise plan</h3>
        <FranchisePlans
          currentPlan={currentPlan}
          planChange={this.planChange}
          isUpgrading={true}
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    franchise: state.franchise.franchiseDetails,
    currentUser: state.user.currentUser,
  }),
  { fetchFranchiseDetails },
)(UpgradeFranchisePlan);
